import update from 'immutability-helper'
import {
  LOGGED_OUT,
  PAY_APPLY_APPLY_APPLICATION_SUCCESS,
  PAY_APPLY_AUTH_PAYMENT_SUCCESS,
  PAY_APPLY_CLEAR_REDIRECTION,
  PAY_APPLY_COAPPLICANT_INFO,
  PAY_APPLY_COST_LOADING,
  PAY_APPLY_CREATE_APPLICATION_SUCCESS,
  PAY_APPLY_CREATE_PAYMENT_SUCCESS,
  PAY_APPLY_CUSTOMER_TYPE,
  PAY_APPLY_DEBIT_PAYMENT_SUCCESS,
  PAY_APPLY_FAILED_IDENTIFICATION,
  PAY_APPLY_FAILED_SIGNING,
  PAY_APPLY_FATAL_ERROR,
  PAY_APPLY_FORM_SPEC,
  PAY_APPLY_SET_DEBIT_REFERENCE,
  PAY_APPLY_FORM_SPEC_DATA,
  PAY_APPLY_GET_ADDRESS_INFO,
  PAY_APPLY_GET_APPLICATION,
  PAY_APPLY_GET_COST_ALTERNATIVES_SUCCESS,
  PAY_APPLY_GET_PAYMENT,
  PAY_APPLY_GET_PAYMENT_METHODS,
  PAY_APPLY_GET_PAYMENT_PER_MONTH,
  PAY_APPLY_GET_STORE_PAYMENT_METHODS,
  PAY_APPLY_GOVERNMENT_ID,
  PAY_APPLY_IDENTIFICATION_STATUS,
  PAY_APPLY_INIT,
  PAY_APPLY_MANUAL_IDENTIFICATION,
  PAY_APPLY_NEW_PAGE_LOADING,
  PAY_APPLY_ON_PAGE_LOADING,
  PAY_APPLY_PAPER_SIGN,
  PAY_APPLY_PAYMENT_PER_MONTH_COST_SUCCESS,
  PAY_APPLY_PENDING_APPLICATIONS_SUCCESS,
  PAY_APPLY_PREPARE_PENDING_APPLICATION_SUCCESS,
  PAY_APPLY_PREPARE_PENDING_PAYMENT_SUCCESS,
  PAY_APPLY_REDIRECTION_DATA_SUCCESS,
  PAY_APPLY_RESET_COST_ALTERNATIVES,
  PAY_APPLY_RESET_CURRENT_PAYMENT_METHOD,
  PAY_APPLY_SELECT_PAYMENT_METHOD,
  PAY_APPLY_SET_CUSTOMER_TYPE,
  PAY_APPLY_SET_DEBIT_AMOUNT,
  PAY_APPLY_SET_ORDER,
  PAY_APPLY_SET_PAGE,
  PAY_APPLY_SET_PAYMENT_DATA,
  PAY_APPLY_SET_PERIOD_OF_REPAYMENT,
  PAY_APPLY_SET_STEP,
  PAY_APPLY_SIGNING_STATUS,
  PAY_APPLY_SELECT_PENDING_PAYMENT_METHOD,
  PAY_APPLY_PUSHED_OUT_TO_CUSTOMER,
  PUSH_OUT_AUTOMATIC_DEBIT,
} from '../actions/action-types'

import { Wizard } from '../../models/wizards'
import { PayApplyType } from '../../models/payapply'
import { CustomerTypeModel } from '../../pages/PayApply/models/private-models'
import { initFormValues } from '../../util/payApplyUtils'

const getSortedList = (list, criteria) => {
  const sortedList = list
  const index = sortedList.findIndex(l => l === criteria)
  if (index > 0) {
    sortedList.splice(0, 0, sortedList.splice(index, 1)[0])
  }
  return sortedList
}

const costMock = false

const costMockValues = [
  {
    monthlyCost: 100,
    months: 10,
  },
  {
    monthlyCost: 200,
    months: 8,
  },
  {
    monthlyCost: 300,
    months: 6,
  },
  {
    monthlyCost: 400,
    months: 4,
  },
  {
    monthlyCost: 500,
    months: 2,
  },
]

const initialState = {
  wizard: {
    customerTypes: [],
    wizard: Wizard.PRIVATE,
    currentStep: 0,
    currentPage: 10,
    previousPage: 10,
    newPageLoading: false,
    newPageLoadedAt: 0,
    onPageLoading: false,
  },
  current: {
    governmentId: null,
    selectedPaymentMethod: null,
    selectedAmount: 0,
    selectedLimit: 0,
    selectedCard: null,
    debitReference: '',
    debitOnMethodId: null,
    status: null,
    id: null,
    type: null,
    fatalError: false,
    fatalErrorMessage: null,
    coApplicant: null,
    account: null,
    costAlternatives: [],
    monthlyCost: {},
    periodOfRepayment: null,
    selectedPendingPaymentMethod: null,
  },
  paymentMethods: null,
  pendingApplications: { applications: null, readyForSigning: false },
  paymentPerMonth: {
    sekkiLinks: null,
    generalTermsLinks: null,
    costList: null,
    costLoading: false,
    paymentMethods: null,
  },
  application: {
    applicationResult: null,
  },
  payment: {
    order: null,
    paymentResult: null,
  },
  redirectionResult: null,
  paymentLogos: null,
  signing: {
    signOnPaper: false,
    signingResult: null,
    signingFailed: false,
  },
  identification: {
    manual: false,
    identificationResult: null,
    identificationFailed: false,
  },
  addressInfo: null,
  formSpec: {
    formSchema: null,
    formValues: null,
  },
  pushedOutToCustomer: false,
  publicSettings: {
    automaticDebit: false,
  },
}

// eslint-disable-next-line default-param-last
const payApply = (state = initialState, action) => {
  switch (action.type) {
    case PAY_APPLY_INIT: {
      return update(initialState, {
        wizard: {
          customerTypes: { $set: state.wizard.customerTypes },
        },
        paymentLogos: { $set: state.paymentLogos },
      })
    }
    case PAY_APPLY_RESET_CURRENT_PAYMENT_METHOD: {
      return update(state, {
        current: {
          $set: {
            ...initialState.current,
            governmentId: state.current.governmentId,
          },
        },
        payment: { $set: initialState.payment },
        application: { $set: initialState.application },
        redirectionResult: { $set: initialState.redirectionResult },
        signing: { $set: initialState.signing },
        identification: { $set: initialState.identification },
        formSpec: { $set: initialState.formSpec },
      })
    }
    case PAY_APPLY_GOVERNMENT_ID:
      return update(state, {
        current: { governmentId: { $set: action.response } },
      })
    case PAY_APPLY_GET_ADDRESS_INFO:
      return update(state, {
        addressInfo: { $set: action.response },
      })
    case PAY_APPLY_GET_PAYMENT_METHODS:
      return update(state, {
        paymentMethods: { $set: action.response },
      })
    case PAY_APPLY_COST_LOADING:
      return update(state, {
        paymentPerMonth: {
          costLoading: { $set: action.status },
        },
      })
    case PAY_APPLY_GET_PAYMENT_PER_MONTH:
      return update(state, {
        paymentPerMonth: {
          sekkiLinks: { $set: action.response && action.response.sekkiLinks },
          generalTermsLinks: {
            $set: action.response && action.response.generalTermsLinks,
          },
          costList: { $set: action.response && action.response.options },
        },
        current: { monthlyCost: { $set: {} } },
      })
    case PAY_APPLY_PAYMENT_PER_MONTH_COST_SUCCESS:
      return update(state, {
        current: {
          monthlyCost: {
            $set: (action.response.costList || [])[0] || {},
          },
        },
        paymentPerMonth: {
          sekkiLinks: { $set: action.response && action.response.sekkiLinks },
          generalTermsLinks: {
            $set: action.response && action.response.generalTermsLinks,
          },
          costList: { $set: null },
        },
      })
    case PAY_APPLY_SET_PERIOD_OF_REPAYMENT:
      return update(state, {
        current: { periodOfRepayment: { $set: action.period } },
      })
    case PAY_APPLY_GET_STORE_PAYMENT_METHODS:
      return update(state, {
        paymentPerMonth: {
          paymentMethods: { $set: action.response },
        },
      })
    case PAY_APPLY_SELECT_PENDING_PAYMENT_METHOD:
      return update(state, {
        current: {
          selectedPendingPaymentMethod: { $set: action.response },
        },
      })
    case PAY_APPLY_SELECT_PAYMENT_METHOD:
      return update(state, {
        current: {
          selectedPaymentMethod: { $set: action.response },
          costAlternatives: { $set: initialState.current.costAlternatives },
          monthlyCost: { $set: initialState.current.monthlyCost },
        },
        payment: { $set: initialState.payment },
        application: { $set: initialState.application },
      })
    case PAY_APPLY_GET_COST_ALTERNATIVES_SUCCESS:
      return update(state, {
        current: {
          costAlternatives: {
            $set: costMock
              ? costMockValues
              : action.response.costList.reverse(),
          },
        },
      })
    case PAY_APPLY_SET_PAYMENT_DATA: {
      return update(state, {
        current: {
          selectedAmount: {
            $set: action.paymentData.debitPaymentChecked
              ? action.paymentData.amount
              : 0,
          },
          selectedLimit: { $set: action.paymentData.limit },
          selectedCard: {
            $set:
              action.paymentData.selectedCard &&
              action.paymentData.selectedCard.cardNumber &&
              !action.paymentData.selectedCard.cardNumber.includes('X')
                ? action.paymentData.selectedCard
                : action.paymentData.card,
          },
          debitOnMethodId: {
            $set: action.paymentData.debitPaymentChecked
              ? action.paymentData.selectedPaymentMethod.id
              : null,
          },
          debitReference: { $set: action.paymentData.debitReference || '' },
          account: {
            $set: {
              accountNumber: action.paymentData.accountNumber,
              cardNumber: (
                action.paymentData.selectedCard ||
                action.paymentData.card ||
                {}
              ).cardNumber,
            },
          },
        },
      })
    }
    case PAY_APPLY_SET_DEBIT_AMOUNT:
      return update(state, {
        current: {
          selectedAmount: {
            $set: action.debitAmount || 0,
          },
        },
      })
    case PAY_APPLY_SET_DEBIT_REFERENCE:
      return update(state, {
        current: {
          debitReference: {
            $set: action.debitReference || '',
          },
        },
      })
    case PAY_APPLY_SET_ORDER:
      return update(state, {
        payment: { order: { $set: action.order } },
        current: { selectedAmount: { $set: action.order.totalAmount } },
      })
    case PAY_APPLY_CREATE_APPLICATION_SUCCESS:
      return update(state, {
        application: { applicationResult: { $set: action.response } },
        current: {
          status: { $set: action.response.status },
          id: { $set: action.response.id },
          type: { $set: PayApplyType.APPLICATION },
        },
      })
    case PAY_APPLY_APPLY_APPLICATION_SUCCESS:
      return update(state, {
        application: { applicationResult: { $set: action.response } },
        current: {
          status: { $set: action.response.status },
          id: { $set: action.response.id },
          type: { $set: PayApplyType.APPLICATION },
        },
      })
    case PAY_APPLY_CREATE_PAYMENT_SUCCESS:
      return update(state, {
        payment: { paymentResult: { $set: action.response } },
        current: {
          status: { $set: action.response.status },
          id: { $set: action.response.id },
          type: { $set: PayApplyType.PAYMENT },
        },
      })
    case PAY_APPLY_AUTH_PAYMENT_SUCCESS:
      return update(state, {
        payment: { paymentResult: { $set: action.response } },
        current: {
          status: { $set: action.response.status },
          id: { $set: action.response.id },
          type: { $set: PayApplyType.PAYMENT },
        },
      })
    case PAY_APPLY_DEBIT_PAYMENT_SUCCESS:
      return update(state, {
        payment: { paymentResult: { $set: action.response } },
        current: {
          status: { $set: action.response.status },
          id: { $set: action.response.id },
          type: { $set: PayApplyType.PAYMENT },
        },
      })
    case PAY_APPLY_REDIRECTION_DATA_SUCCESS:
      return update(state, {
        redirectionResult: { $set: action.url },
      })
    case PAY_APPLY_CLEAR_REDIRECTION:
      return update(state, {
        redirectionResult: { $set: null },
      })
    case PAY_APPLY_SIGNING_STATUS:
      return update(state, {
        signing: { signingResult: { $set: action.status } },
      })
    case PAY_APPLY_IDENTIFICATION_STATUS:
      return update(state, {
        identification: { identificationResult: { $set: action.status } },
      })
    case PAY_APPLY_FAILED_SIGNING:
      return update(state, {
        signing: { signingFailed: { $set: true } },
      })
    case PAY_APPLY_PAPER_SIGN:
      return update(state, {
        signing: { signOnPaper: { $set: true } },
      })
    case PAY_APPLY_FAILED_IDENTIFICATION:
      return update(state, {
        identification: { identificationFailed: { $set: true } },
      })
    case PAY_APPLY_MANUAL_IDENTIFICATION:
      return update(state, {
        identification: { manual: { $set: true } },
      })
    case PAY_APPLY_SET_STEP:
      return update(state, {
        wizard: { currentStep: { $set: action.stepIndex } },
      })
    case PAY_APPLY_SET_PAGE:
      return update(state, {
        wizard: {
          currentPage: { $set: action.pageIndex },
          previousPage: { $set: state.wizard.currentPage },
        },
      })
    case PAY_APPLY_NEW_PAGE_LOADING:
      return update(state, {
        wizard: {
          newPageLoading: { $set: action.status },
          newPageLoadedAt: { $set: new Date().getTime() },
        },
      })
    case PAY_APPLY_ON_PAGE_LOADING:
      return update(state, {
        wizard: { onPageLoading: { $set: action.status } },
      })
    case PAY_APPLY_FATAL_ERROR:
      return update(state, {
        current: {
          fatalError: { $set: true },
          fatalErrorMessage: {
            $set:
              (action &&
                action.response &&
                ((action.response.data && action.response.data.code) ||
                  action.response.code)) ||
              0,
          },
        },
      })
    case PAY_APPLY_FORM_SPEC_DATA:
      return update(state, {
        formSpec: { formValues: { $set: action.data } },
        addressInfo: {
          ...(state.addressInfo.mobilePhoneNumber
            ? {
                mobilePhoneNumber: {
                  value: { $set: action.data['applicant-mobile-number'] },
                },
              }
            : {}),
          ...(state.addressInfo.email
            ? { email: { $set: action.data['applicant-email-address'] } }
            : {}),
        },
      })
    case PAY_APPLY_FORM_SPEC:
      return update(state, {
        formSpec: {
          formSchema: {
            $set: initFormValues(action.response.elements, state),
          },
        },
      })
    case PAY_APPLY_COAPPLICANT_INFO:
      return update(state, {
        current: { coApplicant: { $set: action.response } },
      })
    case PAY_APPLY_PENDING_APPLICATIONS_SUCCESS:
      return update(state, {
        pendingApplications: { applications: { $set: action.data } },
      })
    case PAY_APPLY_PREPARE_PENDING_APPLICATION_SUCCESS:
      return update(state, {
        pendingApplications: { readyForSigning: { $set: true } },
        application: { applicationResult: { $set: action.response } },
        current: {
          status: { $set: action.response.status },
          id: { $set: action.response.id },
          type: {
            $set: PayApplyType.APPLICATION,
          },
        },
      })
    case PAY_APPLY_PREPARE_PENDING_PAYMENT_SUCCESS:
      return update(state, {
        pendingApplications: { readyForSigning: { $set: true } },
        payment: { paymentResult: { $set: action.response } },
        current: {
          status: { $set: action.response.status },
          type: { $set: PayApplyType.PAYMENT },
          selectedPaymentMethod: {
            $set: state.paymentMethods.find(
              method => method.id === action.response.paymentMethod.id,
            ),
          },
          debitOnMethodId: { $set: action.response.paymentMethod.id },
          selectedAmount: {
            $set:
              action.response.payment && action.response.payment.paymentStatus
                ? action.response.payment.paymentStatus.totalOrderAmount
                : 0,
          },
          debitReference: {
            $set: action.response.store
              ? action.response.store.representativeName
              : '',
          },
          id: { $set: action.response.id },
        },
      })
    case PAY_APPLY_CUSTOMER_TYPE:
      return update(state, {
        wizard: {
          customerTypes: {
            $set: getSortedList(
              action.response.customerTypes,
              CustomerTypeModel.NATURAL,
            ),
          },
        },
      })
    case PAY_APPLY_SET_CUSTOMER_TYPE:
      return update(state, {
        wizard: {
          wizard: { $set: action.customerType },
        },
      })
    case PAY_APPLY_GET_APPLICATION:
      return update(state, {
        application: {
          applicationResult: { $set: action.response },
        },
      })
    case PAY_APPLY_GET_PAYMENT:
      return update(state, {
        payment: {
          paymentResult: { $set: action.response },
        },
      })
    case PAY_APPLY_RESET_COST_ALTERNATIVES:
      return update(state, {
        current: {
          costAlternatives: {
            $set: [],
          },
          monthlyCost: {
            $set: {},
          },
        },
        paymentPerMonth: {
          generalTermsLinks: {
            $set: null,
          },
          sekkiLinks: {
            $set: null,
          },
        },
      })
    case PAY_APPLY_PUSHED_OUT_TO_CUSTOMER:
      return update(state, {
        pushedOutToCustomer: {
          $set: true,
        },
      })
    case PUSH_OUT_AUTOMATIC_DEBIT:
      return update(state, {
        publicSettings: {
          automaticDebit: { $set: action.automaticDebit },
        },
      })
    case LOGGED_OUT:
      return initialState
    default:
      return state
  }
}

export default payApply
